import {Locations} from './Locations'
import {Map} from './Map'
import {List} from './List'
import {Tooltip} from "../../../../themes/guthrie_theme/src/js/components/tooltip";

class LandingPage extends DrupalBehavior {

  onContent(context) {
    const self = this;
    super.onContent(context);
    $('#location-search-form', context).each(function(){
      const mapElement = $('[data-map]', context).get(0);
      const listElement = $('[data-listing]', context).get(0);
      if (!mapElement || !listElement) {
        return;
      }
      self.$form = $(this);
      self.$useMyLocation = $('#edit-use-my-location', self.$form);
      self.$zip = $('#edit-zip', self.$form);
      self.$keywords = $('#edit-keywords', self.$form);
      self.$keywords.bind('keyup', e => {
        if (e.keyCode === 13) {
          self.$form.submit();
        }
      });
      self.$currentLocation = $('#current-location', self.$form);
      self.$currentLocation.hide();
      self.$closeCurrentLocation = $('button', self.$currentLocation);
      self.$closeCurrentLocation.click(e => {
        e.preventDefault(); // otherwise submits the form
        self.$useMyLocation.prop('checked', false);
        self.dontUseMyLocation();
      });
      self.$geolocation = $('[data-drupal-selector="edit-geolocation"]', self.$form);
      if (navigator.geolocation) {
        if (self.$useMyLocation.prop('checked')) {
          self.useMyLocation();
        }
        self.$useMyLocation.change(function(e){
          if (self.$useMyLocation.prop('checked')) {
            self.useMyLocation(true);
          } else {
            self.dontUseMyLocation();
          }
        });
      } else {
        self.$useMyLocation.parent().hide();
      }
      self.$openNow = $('#edit-open-now', self.$form);
      if (self.$openNow.prop('checked')) {
        self.settings.locations = self.settings.locations.filter(location => Locations.isOpen(location));
      }
      $('[data-count]').html(Locations.renderCount(self.settings.locations));
      // Timeout is temporary fix.
      setTimeout(() => {
        if (self.settings.locations.length === 0) {
          return;
        }
        new Map(
          mapElement,
          self.$form,
          self.settings.locations,
          self.settings.access_token,
        self.settings.path.baseUrl + 'modules/custom/guthrie_locations/location-pin.png',
          self.settings.path.baseUrl + 'modules/custom/guthrie_locations/location-pin-hover.png'
        );
        new List(
          listElement,
          self.$form,
          self.settings.locations
        );
        const tooltip = new Tooltip();
        tooltip.onContent();
      }, 500);

      new autoComplete({
        selector: 'input[id="edit-keywords"]',
        minChars: 3,
        source: function(term, response){
          $.getJSON('/locations/names', {
            keywords: term
          }, function(data){
            response(data);
          });
        },
        onSelect: () => {
          document.getElementById('location-search-form').submit();
        }
      });

    });
  }

  useMyLocation(submitForm = false) {
    navigator.geolocation.getCurrentPosition(
      position => {
        this.$geolocation.val([position.coords.latitude, position.coords.longitude].join(','));
        this.$useMyLocation.parent('.form-item').hide();
        this.$zip
          .val(null)
          .parent('.form-item')
          .hide();
        this.$currentLocation.show();
        if (submitForm) {
          this.$form.submit();
        }
      },
      _ => {
        this.$useMyLocation.prop('checked', false);
        this.dontUseMyLocation();
      },
      {
        timeout: 10 * 1000
      }
    )
  }

  dontUseMyLocation() {
    this.$geolocation.val(null);
    this.$useMyLocation.parent('.form-item').show();
    this.$zip.parent('.form-item').show();
    this.$currentLocation.hide();
  }

}

DrupalBehavior.register('guthrie_locations', 'landing-page', LandingPage);
